<template>
  <v-app>

    <Navigation title="Picklisten" tabsActive="true">
      <v-tabs background-color="#fff" color="#ff9117" light v-model="model" grow class="elevation-2" show-arrows>
        <v-tab href="#tab-1">
          Offen
        </v-tab>
        <v-tab href="#tab-2">
          In Bearbeitung
        </v-tab>
        <v-tab href="#tab-3">
          Abgeschlossen  
        </v-tab>
      </v-tabs>
    </Navigation>

    <v-content app>
      <v-card class="elevation-0" height="100%">
        <v-tabs-items v-model="model">

          <v-tab-item value="tab-1">
            <OpenPicksList></OpenPicksList>
          </v-tab-item>

          <v-tab-item value="tab-2">
            <InProgressPicksList></InProgressPicksList>
          </v-tab-item>

          <v-tab-item value="tab-3">
            <DonePicksList></DonePicksList>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <v-dialog v-model="dialog.open" max-width="400">
        <v-card>
          <v-card-title>{{dialog.title}}</v-card-title>
          <v-card-text>{{dialog.text}}</v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="#faa619" text @click="dialog.open = false">Abbrechen</v-btn>
            <v-btn color="#faa619" text @click="dialog.action()">Zustimmen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar" :color="snackbarColor">
        {{ selectedPickStatusText }}
        <v-btn color="white" text @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
      
    </v-content>

    <BottomNavigation activeBtn="home"></BottomNavigation>
    
  </v-app>
</template>

<script>
import Navigation from "../components/Navigation";
import OpenPicksList from "../components/OpenPicksList";
import InProgressPicksList from "../components/InProgressPicksList";
import DonePicksList from "../components/DonePicksList";
import BottomNavigation from "../components/BottomNavigation";
import picklistService from "../services/picklistService";
import { mapState } from "vuex";

export default {
  name: "Home",
  data () {
      return {
        model: "tab-1",
        dialog: {
          open: false,
          title: "",
          text: ""
        },
        selectedPickId: null,
        snackbar: false,
        snackbarColor: "white",
        selectedPickStatusText: "",
      }
  },
  components: {
    Navigation,
    OpenPicksList,
    InProgressPicksList,
    DonePicksList,
    BottomNavigation
  },
  computed: mapState({
    openPicks: state => state.picklists.openPicklist,
    workingPicks: state => state.picklists.workingPicklist,
    donePicks: state => state.picklists.donePicklist,
    currentOpenPick: state => state.currentPick.open,
  }),
  created() {
    picklistService.picklist();
    picklistService.missingCounts();
  },
  methods: {

      selectProgressPick(user, id) {

        if(this.$store.getters.connectedUser === user) {
          
          picklistService.picklistDetails(id).then((pickDetail) => {
            console.log(pickDetail);
            this.$store.commit("setCurrentPick", pickDetail);
          });
          return;
        }

        const confirmAction = () => {
          this.takeOver(id);
        };

        this.dialog.open = true;
        this.dialog.title = `Pick von ${user} übernehmen`;
        this.dialog.text = "Drücken Sie auf Zustimmen um den Pick zu übernehmen.";
        this.dialog.action = confirmAction;
      },
  }
};
</script>
<style scoped>
.tab-item-wrapper {
  height: 1000px;
}

</style>